export class EmailTemplateModel{
    public email_body: string = "";
    public email_subject: string = "";
    public template_name: string = "";
    public document_name: string = "";
}